import {
  Box,
  Button,
  DialogContent,
  TextField,
  Tooltip,
  Typography
} from "@mui/material";
import { format, isValid } from "date-fns";
import { MaterialReactTable } from "material-react-table";
import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { appointmentAssist } from "../../../../../../actions/accidentDashboard";
import { attendedAppointment } from "../../../../../../actions/appointments";
import snackbarUtils from "../../../../../../utils/snackbarUtils";
import CustomDialog from "../../../../../commons/dialog/customDialog";
import { tableConfig } from "../../../../../commons/table/config/tableConfig";
import { StyledAppointmentDetailFromForm } from "../../../../../styled/appointments";

const AppointmentDetailFromForm = ({
  open,
  handleClose,
  formTitle,
  appointmentsSelected,
}) => {
  const dispatch = useDispatch();

  const accident = useSelector((state) => state.accidentDashboard.accident);
  const [selectedAppointmentinGrid, setSelectedAppointmentinGrid] = useState(
    [],
  );

  const attended = (appointment) => {
    dispatch(
      attendedAppointment(
        appointment.idTurnoSiniestro,
        accident.mlCloudCoreArtId,
      ),
    );
  };

  const handleSubmitFormAndAppointment = (selectedAppointments) => {
    selectedAppointments.forEach((a) => {
      attended(a.original);
    });
    dispatch(appointmentAssist());
    handleClose();
    setSelectedAppointmentinGrid([]);
    snackbarUtils.success("Turno marcado como concurrido correctamente");
  };

  const handleSubmitForm = () => {
    dispatch(appointmentAssist());
    handleClose();
  };

  const columns = [
    {
      header: "Día",
      accessorKey: "fechaHora",

      Cell: ({ row }) => {
        const date = new Date(row.original.fechaHora);
        return isValid(date) ? format(date, "dd/MM/yyyy") : "-";
      },
      Filter: ({ column }) => {
        const [filterValue, setFilterValue] = useState("");

        return (
          <TextField
            fullWidth
            variant="outlined"
            size="small"
            placeholder="dd/MM/yyyy"
            value={filterValue}
            onChange={(e) => {
              const value = e.target.value;
              setFilterValue(value || "");
              column.setFilterValue(value || undefined);
            }}
          />
        );
      },
      filterFn: (row, columnId, filterValue) => {
        if (!filterValue) return true;

        const date = new Date(row.original[columnId]);
        if (!isValid(date)) return false;

        const cellValue = format(date, "dd/MM/yyyy");
        return cellValue.includes(filterValue);
      },
    },
    {
      header: "Hora",
      accessorKey: "horaFormat",

      Cell: ({ row }) => {
        const date = new Date(row.original.fechaHora);
        return isValid(date) ? format(date, "HH:mm") : "-";
      },
      Filter: ({ column }) => {
        const [filterValue, setFilterValue] = useState("");

        return (
          <TextField
            fullWidth
            variant="outlined"
            size="small"
            placeholder="HH:mm"
            value={filterValue}
            onChange={(e) => {
              const value = e.target.value;
              setFilterValue(value || "");
              column.setFilterValue(value || undefined);
            }}
          />
        );
      },
      filterFn: (row, columnId, filterValue) => {
        if (!filterValue) return true;

        const date = new Date(row.original.fechaHora);
        if (!isValid(date)) return false;

        const cellValue = format(date, "HH:mm");
        return cellValue.includes(filterValue);
      },
    },
    {
      header: "Descripción",
      accessorKey: "descripcion",
      Filter: ({ column }) => {
        const [filterValue, setFilterValue] = useState("");

        return (
          <TextField
            fullWidth
            variant="outlined"
            size="small"
            placeholder="Buscar por texto"
            value={filterValue}
            onChange={(e) => {
              const value = e.target.value;
              setFilterValue(value);
              column.setFilterValue(value || undefined);
            }}
          />
        );
      },
      filterFn: (row, columnId, filterValue) => {
        if (!filterValue) return true;
        return row.original[columnId]
          ?.toString()
          .toLowerCase()
          .includes(filterValue.toLowerCase());
      },
    },
    {
      header: "Profesional",
      accessorKey: "profesionalApellidoNombre",

      muiTableBodyCellProps: {
        sx: {
          whiteSpace: "normal",
          wordWrap: "break-word",
        },
      },
    },
    {
      header: "Especialidad",
      accessorKey: "especialidadNombre",
      muiTableBodyCellProps: {
        sx: {
          whiteSpace: "normal",
          wordWrap: "break-word",
        },
      },
    },
  ];

  return (
    <CustomDialog
      open={open}
      onClose={handleClose}
      fullWidth
      maxWidth="md"
    >
      <StyledAppointmentDetailFromForm.TitleContainer>
        <StyledAppointmentDetailFromForm.Title>
          TURNOS
        </StyledAppointmentDetailFromForm.Title>
        <Tooltip title="Cerrar">
          <StyledAppointmentDetailFromForm.CloseIcon onClick={handleClose} />
        </Tooltip>
      </StyledAppointmentDetailFromForm.TitleContainer>
      <DialogContent>
        <StyledAppointmentDetailFromForm.TableContainer>
          <StyledAppointmentDetailFromForm.ScrollContainer>
            <MaterialReactTable
              {...tableConfig}
              enableRowSelection
              renderBottomToolbar={({ selectedAlert, table }) => (
                <Box
                  sx={{
                    marginTop: "5px",
                    width: "100%",
                    justifyContent: "right",
                    display: "flex",
                  }}
                >
                  <StyledAppointmentDetailFromForm.ActionsContainer>
                    <Button
                      sx={{
                        margin: 1,
                        height: 47,
                      }}
                      onClick={handleClose}
                      color="primary">
                      Cancelar
                    </Button>
                    <Button
                      sx={{
                        margin: 1,
                        height: 47,
                      }}
                      onClick={() => handleSubmitForm()}
                      color="primary"
                      variant="contained">
                      Guardar Formulario
                    </Button>
                    <Button
                      sx={{
                        margin: 1,
                        height: 47,
                      }}
                      onClick={() =>
                        handleSubmitFormAndAppointment(
                          table.getSelectedRowModel().rows,
                        )
                      }
                      color="primary"
                      variant="contained"
                      disabled={table.getSelectedRowModel().rows.length === 0}>
                      Guardar Formulario y Asistencia
                    </Button>
                  </StyledAppointmentDetailFromForm.ActionsContainer>
                </Box>
              )}
              renderTopToolbarCustomActions={({ table }) => (
                <Typography sx={{ fontWeight: "bold" }}>{formTitle}</Typography>
              )}
              columns={columns}
              data={appointmentsSelected}
              initialState={{
                density: "compact",
              }}
            />
          </StyledAppointmentDetailFromForm.ScrollContainer>
        </StyledAppointmentDetailFromForm.TableContainer>
      </DialogContent>
    </CustomDialog>
  );
};

export default AppointmentDetailFromForm;
